export const trimText = (text: string, maxLength: number) => {
  if (!text) return null;

  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const isTextEllipsized = (element: any) => {
  if (!element) {
    return false;
  }

  return (
    element.offsetWidth < element.scrollWidth ||
    element.offsetHeight < element.scrollHeight
  );
};

/**
 * Generates initials. If `lastname` is not provided, `name` is splited on space.
 *
 * @param name - `name` represents the Full Name or First name of the user.
 * @param lastname - (optional) `lastname` represents the Last Name of the user.
 * @returns name initials.
 */

export const generateInitials = (name?: string, lastName?: string) => {
  // Callers pass untyped API data, so coerce anything non-string away instead of
  // throwing on `.trim()`/`.split()` and taking the whole tree down.
  const safeName = typeof name === "string" ? name.trim() : "";
  let safeLastName = typeof lastName === "string" ? lastName.trim() : "";

  if (!safeName && !safeLastName) return null;

  let firstName = safeName;
  if (!safeLastName) {
    [firstName = "", safeLastName = ""] = safeName.split(" ");
  }

  return `${firstName.substring(0, 1).toUpperCase()}${safeLastName
    .substring(0, 1)
    .toUpperCase()}`;
};
